<script setup>
import { reactive } from "vue";
import axios from "axios";
import router from "@/router/index.js";
import { url } from '@/config/urls';

const props = defineProps({
  passwordResetMailApiUrl : {type: String, default: url.api.passwordResetMail},
  forgotPasswordCompletePageUrl: {type: String, default: url.page.passwordReset.forgotPasswordComplete},
  errorPageUrl: {type: String, default: url.error}
});

const input = reactive({
  id: '',
  email: ''
});

const errorMessage = reactive({
  id: '',
  email: ''
});

const mapResponseError = (response, fieldList) => {
  return response.data.error
  .map(errorObject => fieldList.includes(errorObject.field) ? errorObject.message : null)
  .filter(item => item !== null)
  .join('\n');
}

// バリデーションチェック
const validateId = (id) => {
  if (!id) {
    errorMessage.id = 'ログインIDを入力してください。';
  } else if (id.length > 10) {
    errorMessage.id = 'ログインIDは10文字以内で入力してください。';
  } else {
    errorMessage.id = '';
  }
}

const validateEmail = (email) => {
  if (!email) {
    errorMessage.email = 'メールアドレスを入力してください。';
  } else if (email.length > 255) {
    errorMessage.email = 'メールアドレスは255文字以内で入力してください。';
  } else if (!email.match(
      /^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/)) {
    errorMessage.email = 'メールアドレスを正しい形式で入力してください。';
  } else {
    errorMessage.email = '';
  }
}

// 送信ボタン押下時
const onClickSendButton = () => {
  // バリデーションチェック
  validateId(input.id);
  validateEmail(input.email);
  if (errorMessage.id || errorMessage.email) {
    return;
  }
  // パスワード再設定メール送信APIの呼び出し
  const param = {
    loginId: input.id,
    email: input.email
  }
  axios.post(props.passwordResetMailApiUrl, param)
    .then(response => {
      if (response.data.response.sent) {
        sessionStorage.setItem('forgotPasswordEmail', input.email);
        router.push(props.forgotPasswordCompletePageUrl);
      } else {
        errorMessage.current =
          response.data.error.map(errorObject => errorObject.message).join('\n');
      }
    })
    .catch(error => {
      const response = error.response;
      switch (response.status) {
        case 400:
          if (response.data.error instanceof Array) {
            errorMessage.id = mapResponseError(response, ['loginId']);
            errorMessage.email = mapResponseError(response, ['email']);
          } else {
            sessionStorage.setItem('errorHeading', '指定されたページを表示できません。');
            sessionStorage.setItem('errorBody', '申し訳ございませんが、リクエストを正しく処理できませんでした。送信内容が正確であることを確認し、もう一度お試しください。');
            router.push(props.errorPageUrl);
          }
          break;
        case 404:
          errorMessage.email = '一致するアカウントが見つかりません。';
          break;
        default:
          router.push(props.errorPageUrl);
          break;
      }
    });
}
</script>

<template>
  <h2 class="title_sub1">パスワードをお忘れの方</h2>
  <div class="form-group">
    <p class="com_center1s">登録されたメールアドレスに<br>パスワード再設定のメールを送付します</p>
    <div class="com_mgt15 com_mgt10s">
      <input type="text" name="" placeholder="ログインID" class="form-control com_form1 s1 " v-model="input.id" :class="{ error: errorMessage.id }">
        <div class="com_validate_msg1 error" v-if="errorMessage.id">
          {{ errorMessage.id }}
        </div>
      </div>
      <div class="com_show_hide_password1 com_mgt15 com_mgt10s">
        <input type="text" name="" placeholder="メールアドレス" class="form-control com_form1 s1 " v-model="input.email" :class="{ error: errorMessage.email }">
      <div class="com_validate_msg1 error" v-if="errorMessage.email">
        {{ errorMessage.email }}
      </div>
    </div>
    <button type="button" name="" class="btn com_btn3 cl1" @click="onClickSendButton">送信</button>
  </div>
</template>

<style>
.com_validate_msg1.error {
  white-space: pre-wrap;
}
</style>